import React, { useReducer } from "react";

import { CreateRequestAdditionalProps, CreateRequestContext } from "./context";
// import { devInitialState } from "./initialState/devData";
import { initialRequest } from "./initialState/initialState";
import { reducer } from "./reducer";
import { ReservationPaymentSetupProvider } from "./ReservationPaymentSetupProvider";
import type { ReservationSetupReturn } from "./reservationSetupReturn";

const CreateRequestProvider = ({
  children,
  skipVehicleSelectionEnabled,
  skipVehicleDefaultVehicle,
  setupReturn,
}: React.PropsWithChildren<
  CreateRequestAdditionalProps & { setupReturn?: ReservationSetupReturn }
>) => {
  const [createRequestState, dispatch] = useReducer(
    reducer,
    setupReturn?.request || initialRequest
    // devInitialState
  );

  return (
    <CreateRequestContext.Provider
      value={[
        createRequestState,
        dispatch,
        { skipVehicleDefaultVehicle, skipVehicleSelectionEnabled },
      ]}
    >
      <ReservationPaymentSetupProvider setupReturn={setupReturn}>
        {children}
      </ReservationPaymentSetupProvider>
    </CreateRequestContext.Provider>
  );
};

export { CreateRequestProvider };
